import type { AlertProps } from "@tine/designsystem-ui-react";
import { observer } from "mobx-react-lite";
import { type PropsWithChildren, useEffect } from "react";

import { sendErrorMessage } from "../common/tracking";
import type { TrackingInfo } from "../common/types/trackingTypes";

import Button from "./Button";
import TrackedAlert from "./TrackedAlert";

interface ErrorAlertWithOptionalTrackingProps extends Omit<AlertProps, "children"> {
   onRetry?: () => void;
   gaErrorTracking?: TrackingInfo;
   source?: string;
}

const ErrorAlertWithOptionalTracking = ({
   title,
   show = true,
   fullWidth,
   maxWidth,
   showCloseButton,
   cta,
   ctaText,
   ariaLive,
   onClose,
   onRetry,
   gaErrorTracking,
   source = "ErrorAlertWithOptionalTracking",
   className,
   children
}: PropsWithChildren<ErrorAlertWithOptionalTrackingProps>) => {
   useEffect(() => {
      show && gaErrorTracking && sendErrorMessage(gaErrorTracking);
   }, [show]);

   return (
      <TrackedAlert
         variant="error"
         title={title}
         show={show}
         fullWidth={fullWidth}
         maxWidth={maxWidth}
         showCloseButton={showCloseButton}
         cta={cta}
         ctaText={ctaText}
         ariaLive={ariaLive}
         onClose={onClose}
         className={className}
         source={source}
         tracking={gaErrorTracking}
      >
         {children}
         {onRetry && (
            <Button variant="secondary" size="compact" className="mt-2 block" onClick={onRetry}>
               Prøv på nytt?
            </Button>
         )}
      </TrackedAlert>
   );
};

export default observer(ErrorAlertWithOptionalTracking);
